var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.707,11.293l-11-11c-0.391-0.39-1.023-0.39-1.414,0l-11,11c-0.39,0.391-0.39,1.024,0,1.414C0.481,12.895,0.735,13,1,13 h1.25c0.138,0,0.25,0.112,0.25,0.25V23c0,0.552,0.448,1,1,1h5.75c0.138,0,0.25-0.112,0.25-0.25V19c0-1.381,1.119-2.5,2.5-2.5 s2.5,1.119,2.5,2.5v4.75c0,0.138,0.112,0.25,0.25,0.25h5.75c0.552,0,1-0.448,1-1v-9.75c0-0.138,0.112-0.25,0.25-0.25H23 c0.552,0,1-0.448,1-1C24,11.735,23.894,11.48,23.707,11.293z M12,12c-1.381,0-2.5-1.119-2.5-2.5S10.619,7,12,7s2.5,1.119,2.5,2.5 S13.381,12,12,12z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a2fa69b6.svg";
export { ForwardRef as ReactComponent };